export default function AdvantageCard({ icon, title, desc }) {
  return (
    <div className="max-w-[400px] xs:max-w-[350px] p-2 bg-blue-100 flex flex-col items-start rounded-2xl shadow-lg ">
      <div className="flex items-center">
        <img
          className="w-[70px] m-3 h-auto object-contain rounded-full"
          src={icon}
          alt={title}
        />
        <p className="text-[20px] font-extrabold uppercase">{title}</p>
      </div>
      <div className="m-3">
        <p className="text-sm font-bold">{desc}</p>
      </div>
    </div>
  );
}
